import React from 'react';
import Radio from 'ui/elements/form/choice/Radio';
import { FormControlLabel } from '@mui/material';
import { PostTo } from '../types';
import { getValue } from './VisibilitySelector';

export function VisibilityOption({
  value,
  onChange,
  isAtPostLocation = false,
}: {
  value: PostTo;
  isAtPostLocation?: boolean;
  onChange: (postTo: PostTo) => void;
}) {
  const label = getLabel(value, isAtPostLocation);
  const subLabel = getSubLabel(value, isAtPostLocation);

  return (
    <FormControlLabel
      className="u-half-spacing-bottom"
      control={<Radio />}
      value={getValue(value)}
      onChange={() => onChange(value)}
      label={
        subLabel ? (
          <div>
            <div className="u-flex u-flex--align-items-center" style={{ gap: '0.4rem' }}>
              {label}
            </div>
            <div style={{ fontWeight: 'normal' }}>{subLabel}</div>
          </div>
        ) : (
          label
        )
      }
    />
  );
}

export function getLabel(postTo: PostTo, isAtPostLocation: boolean) {
  if (postTo.type === 'company') {
    switch (postTo.visibility) {
      case 'Public':
        return 'Anyone';
      case 'Private':
        return 'Shareholders & board members';
      default:
        return 'Company update';
    }
  }

  if (postTo.type === 'community') {
    switch (postTo.visibility) {
      case 'CommunityMembers':
        return isAtPostLocation ? 'Community members' : postTo.profile.name;
      case 'Founders':
        return isAtPostLocation ? 'Founders' : postTo.profile.name;
      case 'CommunityMembersExceptFounders':
        return isAtPostLocation ? 'Investors, mentors & advisors' : postTo.profile.name;
    }
  }

  return 'Invalid postTo type or visibility';
}

export function getSubLabel(postTo: PostTo, isAtPostLocation: boolean) {
  if (postTo.type === 'company') {
    switch (postTo.visibility) {
      case 'Public':
        return 'Anyone on CrowdWorks';
      case 'Private':
        return 'Approved members of the company';
    }
  }

  if (postTo.type === 'community') {
    switch (postTo.visibility) {
      case 'CommunityMembers':
        return `Everyone in ${postTo.profile.name}`;
      case 'CommunityMembersExceptFounders':
        return isAtPostLocation ? undefined : getLabel(postTo, true);
      case 'Founders':
        return isAtPostLocation ? undefined : getLabel(postTo, true);
    }
  }

  return undefined;
}
